<template>
    <section>
        <TopAppBarDrawer></TopAppBarDrawer>
        <main class="main-wrapper flex-grow-1 with-footer">
                <div class="d-flex align-items-center ">
                        <div class="t-headline13 t-color-headlineBlack pda-14 font-m flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center">
                                {{$t('1202')}}
                        </div>
                    <div class="mgr-24 right-button">
                        <button type="button" class="mdc-button mdc-dialog__button" data-mdc-dialog-action="discard" @click="$router.go(-1)" @keypress="$router.go(-1)" tabindex="0">
                            <div class="mdc-button__ripple"></div>
                            <span class="mdc-button__label t-color-iconActive font-r">{{$t('3317')}}</span>
                        </button>
                    </div> 
                </div>
                <div class="divider"></div> 
                <!-- subtabs -->
                
                <div class="container container--narrow mgt-30 pdb-50" id="chat">
                    <div id="chatContainer" class=" flex-grow-1 scroll-y bg-white">
                        <div class="w-full pdb-34">
                            <ul>
                                    <li v-for="(chat, index) in chatData" :key="index">
                                        
                                        <div class="datetime"
                                            v-if="index === 0 || (index > 0 && $moment(chat.created).diff($moment(chatData[index-1].created),'days') > 0)" 
                                        >
                                            <span class="t-helper">

                                                {{$moment(chat.created).format('LL')}}
                                            </span>
                                        </div>
                                        <div class="chat-body"
                                            :class="{
                                                'me': !chat.owner,
                                                'other': chat.owner,
                                                'with-avatar': index === 0 && chat.owner,
                                                'with-avatar': index > 0 && chatData[index-1].owner !== chat.owner && chat.owner,
                                                'first': index > 0 && chatData[index-1].owner !== chat.owner,
                                            }"
                                        >
                                            <div class="picture" v-if="chat.owner">
                                                <img class="avatar" src="/images/qna_chat.png" alt="" v-if="index === 0 && chat.owner || (index > 0 && chatData[index-1].owner !== chat.owner && chat.owner)"/>
                                                <!-- <img class="avatar" :src="chat.writerProfile" alt="Avatar"/> -->
                                            </div>
                                            
                                            <div class="text">
                                                <span class="t-body3">
                                                    {{chat.contents ? chat.contents : 'No Message'}}
                                                </span>
                                                <!-- <div v-if="index > 0">
                                                    {{$moment(chat.created).format('L')}}
                                                    <br>{{$moment(chatData[index-1].created).format('L')}}
                                                    <br>{{$moment(chat.created).diff($moment(chatData[index-1].created),'days')}}
                                                </div> -->
                                            </div>
                                            <span class="t-helper">
                                                {{$moment(chat.created).format('LT')}}
                                                <!-- {{$moment(chat.created).format('L')}} -->
                                            </span>
                                        </div>
                                    </li>
                                </ul>		
                        </div>
                    </div>
                </div>

                <!-- <infinite-loading @infinite="fetchData" :identifier="infiniteId" spinner="spiral" force-use-infinite-wrapper="#chatContainer">
                    <div slot="no-more" class="t-color-white">
                    </div>
                    <div slot="no-results" class="t-color-white">
                    </div>
                    <div slot="spinner"></div>
                </infinite-loading> -->

                <div class="footer bg-white bottomStack">
                    <div class="divider"></div>
                        <div class="container container--narrow pdb-0 dkcontainer">
                            <div class="d-flex align-items-center justify-content-between pdt-1 pdb-1">
                                <div class="w-full d-flex align-items-center justify-content-between pdt-2 pdb-2">
                                    <textarea class="video-chat-textarea mdc-text-field__input comment_textarea t-body6 font-r l-spacing42  mgt-12 mgb-8 pdl-25 pdr-23 t-color-textfieldGuid"
                                        rows="1" :placeholder="$t('1203')" id="autoheighttext"  v-model="contents" ref="msg">
                                    </textarea>
                                    <button class="mdc-icon-button  sendMessageBtnExam t-color-iconInactive align-items-center justify-content-between"
                                        @click="sendChat()" @keypress="sendChat()" :disabled="!isSendBtn" tabindex="0">
                                        <i class="material-icons  min-w-26 min-h-27">arrow_upward</i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    <div class="divider-white"></div>
                </div>
        </main>
    </section>

    <!-- <div class="modal-mask" id="chat">
        <div class="modal-wrapper">
            <div class="modal-container d-flex flex-column">
                <header class="mdc-top-app-bar position-static">
                    <div class="mdc-top-app-bar__row">
                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                            <a class="material-icons mdc-top-app-bar__navigation-icon" @click="$router.go(-1)">close</a>
                        </section>
                        <section class="mdc-top-app-bar__section title">
                            <div class="mdc-top-app-bar__title">
                                {{$t('1202')}}
                                
                            </div>                
                        </section>
                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
                            <a class="material-icons mdc-top-app-bar__action-item" aria-label="search" alt="search"></a>
                        </section>
                    </div>
                </header>
                <section class="flex-grow-1 scroll-y">
                    <section id="chatContainer">
                        <ul>
                            <li v-for="(chat, index) in chatData" :key="index">
                                
                                <div class="datetime"
                                    v-if="index === 0 || (index > 0 && $moment(chat.created).diff($moment(chatData[index-1].created),'days') > 0)" 
                                >
                                    <span class="t-helper">

                                        {{$moment(chat.created).format('LL')}}
                                    </span>
                                </div>
                                <div class="chat-body"
                                    :class="{
                                        'me': !chat.owner,
                                        'other': chat.owner,
                                        'with-avatar': index === 0 && chat.owner,
                                        'with-avatar': index > 0 && chatData[index-1].owner !== chat.owner && chat.owner,
                                        'first': index > 0 && chatData[index-1].owner !== chat.owner,
                                    }"
                                >
                                    <div class="picture" v-if="chat.owner">
                                        <img class="avatar" src="../../assets/woman-head.png" alt="" v-if="index === 0 && chat.owner || (index > 0 && chatData[index-1].owner !== chat.owner && chat.owner)"/>
                                        
                                    </div>
                                    
                                    <div class="text">
                                        <span class="t-body3">
                                            {{chat.contents ? chat.contents : 'No Message'}}
                                        </span>
                                        
                                    </div>
                                    <span class="t-helper">
                                        {{$moment(chat.created).format('LT')}}
                                        
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </section>
                </section>
                <section>
                    <form @submit.prevent="sendChat()" novalidate>
                    <section id="messageContainer">
                        <input type="text" :placeholder="$t('1203')" v-model="contents"/>
                        <button class="mdc-icon-button" id="btnSend" @click="sendChat()" :class="{'on': isContents}" :disabled="!isContents"></button>
                        <div class="clearfix"></div>                                
                    </section>
                    </form>
                </section>
                
                
            </div>
        </div>
    </div> -->

</template>

<script>
/**
 * 멤버십 - 구매 상세 질문하기 컴포넌트(membership - purchase question component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import salesApi from '@/api/salesApi.js'
import { fileMixin } from '@/mixins/file.js'
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";
export default {
    data() {
        return {
            orderId: this.$route.params.orderId,
            contents: '',
            attachments: [],
            chatData: [],
			currentPage: 1,
			totalPages: 1,
			showExamListChat :false,
			infiniteId: +new Date(),
        }
    },

    mixins: [fileMixin],

    components: {
        TopAppBarDrawer
    },

    mounted() {
        let params = {
            orderId: this.orderId
        }

        // get qna list
        salesApi.salesQnAList(params).then((response) => {
            this.chatData = response.data.data
        }).catch((err) => {

        })
    },

    updated() {
        this.moveScrollBottom()
    },

    // computed: {
    //     isContents() {        
    //         return !!this.contents
    //     }

    // },

    computed: {
        isSendBtn() {        
            return !!this.contents || !!this.attachments.length
        },

        isAttachments() {
            return this.attachments.length
        }
    },

    methods: {

        // initData() {
		// 	this.listData = [];
		// 	this.currentPage = 1;
		// 	this.totalPages = 1;
		// 	this.infiniteId += 1
		// },

        // fetchData($state) {

        // },
        
        // regist question
        sendChat() {
            let params = {
                orderId: this.orderId,
                contents: this.contents,
                //attachments: this.attachments
            }

            salesApi.salesQnAWrite(params).then((response) => {
                this.chatData.push(response.data.data)
            }).catch((err) => {

            })
            
            this.contents = ''
        },

        moveScrollBottom() {
            let container = this.$el.querySelector("#chatContainer")
            container.scrollTop = container.scrollHeight

        }
    }
}
</script>

<style scoped>
	/* .video-chat-textarea{
		width: calc(100% - 32px);
	} */
	.sendMessageBtn i {
    background: var(--WhiteHigh);
    /* color: #383838 !important; */
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 16px;
}

.sendMessageBtnExam i {
	background: var(--Iconinactive);
    color:#FFF !important;
    border-radius: 50%;
    width: 26px;
    height: 27px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 16px;
	box-sizing: border-box;
}
.square-image.attached-image-preview-QA {
    max-width: 48px;
    position: relative;
}
.remove-image-new {
    top: -10px;
    right: -10px;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    background: var(--Iconinactive);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border: 2px solid var(--DocumentWhite);
    color: var(--DocumentWhite);
    line-height: 0px;
    cursor: pointer;
}
html[rtl="dir"] .remove-image-new {
    left: -10px;
}
</style>